import React, { useEffect, useState } from 'react';
import { Box, Grid } from '@mui/material';
import MainTitle from 'components/MainTitle';
import PlaceMap from 'components/Map/PlaceMap';
import { ButtonTab, Container, Map } from './styles';
import SearchMap from 'components/Map/SearchMap';
import BasicServiceItem from 'features/Services/components/BasicServiceItem';
import SelectComponent from 'components/Select';
import PublicService from 'services/PublicService';
import IService from 'interfaces/IService';
import { useLoading } from 'hooks/useLoading';
import TransportsList from 'features/Transports/pages/List';

const Services = (): JSX.Element => {
  const [searchTerm, setSearchTerm] = useState('');
  const [currentService, setCurrentService] = useState<IService | undefined>();
  const [selectedButton, setSelectedButton] = useState(0);
  const { openLoading, closeLoading } = useLoading();
  const [basicService, setBasicService] = useState<IService[]>([]);

  const service = new PublicService();

  useEffect(() => {
    getBasicService();
  }, []);

  const getBasicService = async () => {
    try {
      openLoading();
      const data = await service.getAllBasicService();
      setBasicService(data);
      if (data.length > 0) {
        setSearchTerm(`${data[0].searchTerm} em Porto Seguro, BA`);
        setCurrentService(data[0]);
        setSelectedButton(0);
      }
      closeLoading();
    } catch (error) {
      closeLoading();
    }
  };

  const handleButtonClick = (current: IService, index: number) => {
    if (current.searchTerm) {
      setSearchTerm(`${current.searchTerm} em Porto Seguro, BA`);
    } else {
      setSearchTerm('');
    }
    setCurrentService(current);
    setSelectedButton(index);
  };

  const handleSelectChange = (selectedValue: string | string[]) => {
    const value = Array.isArray(selectedValue) ? selectedValue[0] : selectedValue;

    if (value === String(selectedButton)) return;

    if (value === undefined) {
      return;
    }

    const index = Number(value);
    if (index === basicService.length) {
      setCurrentService(undefined);
      setSelectedButton(index);
    } else {
      const current = basicService[index];
      if (current) {
        handleButtonClick(current, index);
      }
    }
  };

  const selectOptions = [
    ...basicService.map((service, index) => ({
      label: service.description,
      value: String(index),
    })),
    { label: 'Transportes', value: String(basicService.length) },
  ];

  return (
    <Container>
      <MainTitle>Serviços Básicos</MainTitle>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={3} className="buttons-grid" xl={12} md={12} sm={12}>
          {basicService.map((value, index) => (
            <Grid item xl={2} md={2} sm={4} key={`service-${index}`}>
              <ButtonTab
                className="basic-service-button"
                onClick={() => handleButtonClick(value, index)}
                data-active={selectedButton === index}>
                {value.description}
              </ButtonTab>
            </Grid>
          ))}
          <Grid item xl={2} md={2} sm={4}>
            <ButtonTab
              className="basic-service-button"
              onClick={() => {
                setSelectedButton(basicService.length);
                setCurrentService(undefined);
              }}
              data-active={selectedButton === basicService.length}>
              TRANSPORTES
            </ButtonTab>
          </Grid>
        </Grid>

        <Grid className="select-grid-mobile" item xs={12} md={12}>
          <SelectComponent
            label="Selecione o serviço"
            options={selectOptions}
            selected={[String(selectedButton)]}
            onChange={selectedValue => handleSelectChange(selectedValue)}
          />
        </Grid>

        {selectedButton === basicService.length ? (
          <TransportsList />
        ) : (
          <>
            {(currentService?.phone ||
              currentService?.email ||
              currentService?.links ||
              currentService?.serviceDescription ||
              currentService?.openingHours) && (
              <BasicServiceItem
                email={currentService?.email}
                phone={currentService?.phone}
                links={currentService?.links}
                serviceDescription={currentService?.serviceDescription}
                openingHours={currentService?.openingHours}
              />
            )}

            <Grid container>
              <Grid item xs={12}>
                <Map>{searchTerm ? <SearchMap q={searchTerm} /> : <PlaceMap q="Porto Seguro, BA" />}</Map>
              </Grid>
            </Grid>
          </>
        )}
      </Box>
    </Container>
  );
};

export default Services;
